export const getTokenFromHash = () => {
	const token =
		!!window?.location?.hash?.match(new RegExp(/token=([-_abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890.]*)/, 'i'))
			? decodeURIComponent(window.location.hash.match(new RegExp(/token=([-_abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890.]*)/, 'i'))[1])
			: '';
	return token;
};
